import React from "react";
import Mirror from "components/animation/hero/Mirror";
import Bgsection from "./Bgsection";
import GridTile from "./GridTile";

function HeroSection() {
  return (
    <div className="container-fluid bg-banner-img position-relative pb-md-0 py-5 z-index-1 px-0 ">
      <Bgsection />
      {/* <GridTile /> */}

      <div className="container">
        <div className="row hw-100">
          <div className="col-lg-6 col-md-6 col-sm-6  d-flex justify-content-md-start  justify-content-center align-items-center">
            <div className="banner-left-area my-md-5 mt-5 text-md-start text-center">
              <h2 className="fs-112 hc fw-700 l-h-0-9 m-0 text-uppercase">
                The IRON
              </h2>
              <p className="fs-96 custom-color-blue fw-300 text-uppercase l-h-0-9 m-0">
                NEVER LIES
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6   align-items-center d-flex px-0 justify-content-md-start justify-content-sm-start justify-content-center">
            <Mirror />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
